webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vueMdl = __webpack_require__(18);
	
	var _vueMdl2 = _interopRequireDefault(_vueMdl);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(10);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Map = __webpack_require__(13);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _Data = __webpack_require__(12);
	
	var _Data2 = _interopRequireDefault(_Data);
	
	var _vueRouter = __webpack_require__(20);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(19);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(8);
	__webpack_require__(9);
	
	_vue2.default.use(_vueMdl2.default);
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{ path: '/data', component: _Data2.default }, { path: '/map', component: _Map2.default }, { path: '/', component: _App2.default }, { path: '*', redirect: '/' }];
	
	var router = new _vueRouter2.default({
	  routes: routes
	});
	
	new _vue2.default({
	  router: router
	}).$mount('#app');

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'chart',
	    data: function data() {
	        return {
	            bikeSampleData: [] };
	    },
	    created: function created() {},
	    mounted: function mounted() {
	        this.getSampleBikes();
	    },
	
	    methods: {
	        formatData: function formatData() {},
	        getSampleBikes: function getSampleBikes() {
	            this.$http.get('/static/sample_data/toronto_bike_data.json').then(function (data) {
	                this.bikeSampleData = data.body;
	                this.makeLineChart();
	                this.makeBarGraph();
	            }).catch(function (error) {
	                console.log(error);
	            });
	        },
	        makeBarGraph: function makeBarGraph() {
	            var d3 = window.d3;
	
	            var margin = { top: 30, right: 20, bottom: 70, left: 50 };
	            var width = 960 - margin.left - margin.right;
	            var height = 500 - margin.top - margin.bottom;
	
	            var x = d3.scaleBand().range([0, width]).padding(0.1);
	            var y = d3.scaleLinear().range([height, 0]);
	
	            var svg = d3.select('#visualization-bar-graph').append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            this.bikeSampleData.forEach(function (d) {
	                d.cyclists = +d.cyclists;
	            });
	
	            x.domain(this.bikeSampleData.map(function (d) {
	                return d.date;
	            }));
	            y.domain([0, d3.max(this.bikeSampleData, function (d) {
	                return d.cyclists;
	            })]);
	
	            svg.selectAll('.bar').data(this.bikeSampleData).enter().append('rect').attr('class', 'bar').attr('x', function (d) {
	                return x(d.date);
	            }).attr('width', x.bandwidth()).attr('y', function (d) {
	                return y(d.cyclists);
	            }).attr('height', function (d) {
	                return height - y(d.cyclists);
	            }).style('fill', '#0065a4');
	
	            svg.append('g').attr('transform', 'translate(0,' + height + ')').call(d3.axisBottom(x));
	
	            svg.append('text').attr('transform', 'translate(' + width / 2 + ' ,' + (height + margin.top + 20) + ')').style('text-anchor', 'middle').style('font', '16px Roboto').text('Dates');
	
	            svg.append('g').call(d3.axisLeft(y));
	
	            svg.append('text').attr('transform', 'rotate(-90)').attr('y', 0 - margin.left).attr('x', 0 - height / 2).attr('dy', '1em').style('font', '16px Roboto').style('text-anchor', 'middle').text('Cyclists');
	
	            svg.append('text').attr('x', width / 2).attr('y', 0 - margin.top / 2).attr('text-anchor', 'middle').style('font', ' 16px Roboto').style('text-decoration', 'underline').text('Number of Cyclists Each Day -- Adelaide & Brant');
	        },
	        makeLineChart: function makeLineChart() {
	            var d3 = window.d3;
	
	            var margin = { top: 30, right: 20, bottom: 70, left: 50 };
	            var width = 960 - margin.left - margin.right;
	            var height = 500 - margin.top - margin.bottom;
	
	            var legendSpacing = 25;
	            var legendX = 0;
	
	            var legend = null;
	
	            var parseDate = d3.timeParse('%H:%M:%S');
	            var formatDate = d3.timeFormat('%A, %B %-d, %Y');
	
	            var x = d3.scaleTime().range([0, width]);
	            var y = d3.scaleLinear().range([height, 0]);
	
	            var cyclistsLine = d3.line().x(function (d) {
	                return x(d.timestamp);
	            }).y(function (d) {
	                return y(d.cyclists);
	            });
	
	            var svg = d3.select('#visualization-line-chart').append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            this.bikeSampleData.forEach(function (d) {
	                d.timestamp = parseDate(d.timestamp);
	                d.cyclists = +d.cyclists;
	            });
	
	            x.domain(d3.extent(this.bikeSampleData, function (d) {
	                return d.timestamp;
	            }));
	            y.domain([0, d3.max(this.bikeSampleData, function (d) {
	                return d.cyclists;
	            })]);
	
	            var dataNest = d3.nest().key(function (d) {
	                return d.date;
	            }).entries(this.bikeSampleData);
	
	            var color = d3.scaleOrdinal(d3.schemeCategory10);
	
	            dataNest.forEach(function (d, i) {
	                console.log(d);
	                svg.append('path').attr('class', 'line').style('stroke', function () {
	                    d.color = color(d.key);
	                    return d.color;
	                }).style('fill', 'none').attr('d', cyclistsLine(d.values));
	
	                var y = i * legendSpacing;
	
	                var legendDate = new Date(d.key);
	                legendDate.setDate(legendDate.getDate());
	
	                legend = svg.append('g').attr('class', 'legend').attr('transform', 'translate(' + legendX + ',' + y + ')');
	
	                legend.append('rect').attr('x', width - 18).attr('y', 18).attr('width', 18).attr('height', 18).style('fill', d.color);
	
	                legend.append('text').style('font', '14px Roboto').attr('x', width - 24).attr('y', 25).attr('dy', '.35em').style('text-anchor', 'end').text(formatDate(legendDate));
	            });
	
	            svg.append('g').attr('class', 'axis').attr('transform', 'translate(0,' + height + ')').style('font', '11px Roboto').call(d3.axisBottom(x).ticks(d3.timeHour, 1).tickFormat(d3.timeFormat('%-I %p')));
	            svg.append('text').attr('transform', 'translate(' + width / 2 + ' ,' + (height + margin.top + 20) + ')').style('text-anchor', 'middle').style('font', '16px Roboto').text('Time Range');
	
	            svg.append('g').attr('class', 'axis').style('font', '11px Roboto').call(d3.axisLeft(y));
	
	            svg.append('text').attr('transform', 'rotate(-90)').attr('y', 0 - margin.left).attr('x', 0 - height / 2).attr('dy', '1em').style('font', '16px Roboto').style('text-anchor', 'middle').text('Cyclists');
	
	            svg.append('text').attr('x', width / 2).attr('y', 0 - margin.top / 2).attr('text-anchor', 'middle').style('font', ' 16px Roboto').style('text-decoration', 'underline').text('Cyclists vs Time -- Adelaide & Brant');
	        }
	    }
	};

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Chart = __webpack_require__(11);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Data',
	  components: {
	    Chart: _Chart2.default
	  },
	  data: function data() {
	    return {
	      bikes: {}
	    };
	  },
	
	  created: function created() {},
	  filters: {
	    capitalize: function capitalize(value) {
	      if (!value) return '';
	      value = value.toString();
	      if (value.indexOf(' ') !== -1) {
	        var capitalizedValue = '';
	        var valArr = value.split(' ');
	        for (var i = 0; i < valArr.length; i++) {
	          capitalizedValue += valArr[i].charAt(0).toUpperCase() + valArr[i].slice(1);
	          if (i !== valArr.length - 1) {
	            capitalizedValue += ' ';
	          }
	        }
	        return capitalizedValue;
	      }
	      return value.charAt(0).toUpperCase() + value.slice(1);
	    }
	  },
	  methods: {
	    reverseMessage: function reverseMessage() {
	      this.btnMessage = "Testing the Vue 'once' directive";
	    },
	    nameChange: function nameChange() {
	      this.fullName = 'John Doe';
	    }
	  },
	  computed: {
	    reversedMessage: function reversedMessage() {
	      return this.msg.split('').reverse().join('');
	    },
	    fullName: {
	      get: function get() {
	        return this.firstName + ' ' + this.lastName;
	      },
	      set: function set(newValue) {
	        var name = newValue.split(' ');
	        this.firstName = name[0];
	        this.lastName = name[name.length - 1];
	      }
	    }
	  }
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'hello',
	  data: function data() {
	    return {
	      msg: 'Map Coming Soon'
	    };
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 5 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 6 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 7 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 8 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 9 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(7)
	
	/* template */
	var __vue_template__ = __webpack_require__(17)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6680b4ae"
	
	module.exports = __vue_exports__


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(4)
	
	/* script */
	__vue_exports__ = __webpack_require__(1)
	
	/* template */
	var __vue_template__ = __webpack_require__(14)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-02d63db0"
	
	module.exports = __vue_exports__


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(5)
	
	/* script */
	__vue_exports__ = __webpack_require__(2)
	
	/* template */
	var __vue_template__ = __webpack_require__(15)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2dadc950"
	
	module.exports = __vue_exports__


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(6)
	
	/* script */
	__vue_exports__ = __webpack_require__(3)
	
	/* template */
	var __vue_template__ = __webpack_require__(16)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-38198426"
	
	module.exports = __vue_exports__


/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('div', [_vm._h('svg', {
	    attrs: {
	      "id": "visualization-line-chart"
	    }
	  }), " ", _vm._h('svg', {
	    attrs: {
	      "id": "visualization-bar-graph"
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('div', [_vm._h('div', [_vm._h('div', {
	    staticClass: "col-xs-12 col-sm-10 col-md-8 col-lg-8"
	  }, [_vm._h('chart', {
	    attrs: {
	      "bike-data": _vm.bikes
	    }
	  })])])])
	},staticRenderFns: []}

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "hello"
	  }, [_vm._h('h1', [_vm._s(_vm.msg)])])
	},staticRenderFns: []}

/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "welcome-card",
	    attrs: {
	      "id": "app"
	    }
	  }, [_vm._h('div', {
	    staticClass: "demo-card-wide mdl-card mdl-shadow--2dp"
	  }, [_vm._m(0), " ", _vm._m(1), " ", _vm._m(2), " ", _vm._h('div', {
	    staticClass: "mdl-card__actions mdl-card--border"
	  }, [_vm._h('router-link', {
	    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
	    attrs: {
	      "to": "/data"
	    }
	  }, [_vm._h('i', {
	    staticClass: "material-icons"
	  }, ["timeline"])]), " ", _vm._h('router-link', {
	    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
	    attrs: {
	      "to": "/map"
	    }
	  }, [_vm._h('i', {
	    staticClass: "material-icons"
	  }, ["explore"])])]), " ", _vm._m(3)])])
	},staticRenderFns: [function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "mdl-card__title"
	  })
	},function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "mdl-card__supporting-text"
	  }, ["\n      This website is dedicated to visualizing bike data supplied by the City of Toronto. Specifically, this website\n        visualizes bicycle traffic throughout the downtown core. It is visualized in two ways; through charts/graphs\n        using D3JS and by using a map (coming soon).\n      "])
	},function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "mdl-card__supporting-text"
	  }, ["\n      The purpose of visualizing this data is to help better understand the amount of bike traffic the City of Toronto\n      has on its roads, when it occurs the most, and where it occurs the most. Check out the visualization below.\n      "])
	},function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "mdl-card__menu"
	  }, [_vm._h('button', {
	    staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
	  }, [_vm._h('i', {
	    staticClass: "material-icons"
	  }, ["share"])])])
	}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.93640575e8b141487443.js